import axios from 'axios';
import { urls } from '../config';
import { contextApp } from 'context';

export const useApiPersons = () => {
 const { auth } = contextApp();

 const PersonApi = axios.create({
  baseURL: urls.person(),
  headers: { 'x-access-token': auth?.token }
 });

 /*  const createOrUpdateSetting = async newSetting => (await SettingApi.post(`/${company}`, newSetting)).data;
 const getSetting = async (query = null) => (await SettingApi.get(`/${company}`, { params: query })).data; */

 const getPersonByDoc = async ({ docType, docNumber }) => (await PersonApi.get(`/${docType}/${docNumber}`)).data;

 const createEntity = async newPerson => (await PersonApi.post('/', newPerson)).data;

 const createCustomer = async newCustomer => (await PersonApi.post('/customer', newCustomer)).data;

 const updateEntity = async ({ _id, ...newEntity }) => (await PersonApi.patch('/' + _id, newEntity)).data;

 const updateCustomer = async ({ _id, ...newEntity }) => (await PersonApi.patch('/customer/' + _id, newEntity)).data;

 return { createEntity, createCustomer, getPersonByDoc, updateEntity, updateCustomer };
};

export const getPerson = async (token, id) => {
 const url = urls.person(id);
 const headers = { 'x-access-token': token };
 const settings = await axios.get(url, { headers });
 return settings.data;
};

export const getPersonByDoc = async ({ token, docType, docNumber }) => {
 const url = urls.person(`${docType}/${docNumber}`);
 const headers = { 'x-access-token': token };
 const settings = await axios.get(url, { headers });
 return settings.data;
};

export const getPersons = async token => {
 const url = urls.settings;
 const headers = { 'x-access-token': token };
 const settings = await axios.get(url, { headers });
 return settings.data;
};

export const updatePerson = async (token, newData, id) => {
 const url = urls.person(id);
 const headers = { 'x-access-token': token };
 const settings = await axios.patch(url, newData, { headers });
 return settings.data;
};

export const createPerson = async (token, newPerson, typePeson) => {
 const url = urls.person(typePeson);
 const headers = { 'x-access-token': token };
 const settings = await axios.post(url, newPerson, { headers });
 return settings.data;
};

export default {
 getPerson,
 getPersons,
 updatePerson,
 createPerson,
 getPersonByDoc
};

/* 
*****************************DESCRIPCION GENERAL*********************

Este código es un módulo de API en JavaScript que utiliza la librería Axios para realizar llamadas HTTP a una API externa. El módulo incluye cuatro funciones que realizan diferentes operaciones de CRUD (Creación, Lectura, Actualización y Eliminación) en un recurso de "persona".

La función getPerson toma dos argumentos: token y id. La función construye una URL para la llamada GET a la API utilizando la función urls.person(id). La URL incluye un identificador de persona específico en su ruta. Luego, establece un objeto de cabecera headers que incluye el token de acceso en el formato requerido por la API. Finalmente, la función realiza la llamada GET a la API usando Axios y devuelve los datos obtenidos en el cuerpo de la respuesta.

La función getPersons toma un solo argumento: token. Esta función también construye una URL para la llamada GET a la API utilizando la propiedad urls.settings. No incluye un identificador de persona específico en su ruta, por lo que esta función debe devolver una lista de todas las personas. Al igual que en la función anterior, establece un objeto de cabecera headers que incluye el token de acceso. Finalmente, realiza la llamada GET a la API y devuelve los datos obtenidos en el cuerpo de la respuesta.

La función updatePerson toma tres argumentos: token, newData y id. Esta función construye una URL para la llamada PATCH a la API utilizando la función urls.person(id), que incluye un identificador de persona específico en su ruta. Luego, establece un objeto de cabecera headers que incluye el token de acceso. Finalmente, la función realiza la llamada PATCH a la API usando Axios y los datos proporcionados en newData como el cuerpo de la solicitud. La función devuelve los datos obtenidos en el cuerpo de la respuesta.

 La función  "createPerson"  toma tres parámetros: el token de autenticación, los datos de la persona a crear y el tipo de persona a crear.
Dentro de la función, se utiliza la función urls.person() para obtener la URL a la que se enviará la solicitud para crear una persona. La URL se compone del host y la ruta "/api/person" seguida del tipo de persona especificado como argumento.
Luego, se definen las cabeceras de la solicitud, que incluyen el token de autenticación. Finalmente, se hace una solicitud POST utilizando la biblioteca Axios, que envía los datos de la persona nueva a la URL especificada y recibe la respuesta del servidor. La respuesta se devuelve como resultado de la función.

Luego, hay un objeto llamado "authGoogle" que contiene información de configuración para la autenticación de Google, incluidas las identificaciones del cliente, la identificación del proyecto, la dirección URL de autenticación, la dirección URL del token, la dirección URL del proveedor de certificados, el secreto del cliente y las direcciones URL de origen de javascript.

Finalmente, el último export default combina todas las constantes y objetos anteriores en un objeto único, incluyendo la versión, el punto de interrupción de la barra de navegación, el punto de interrupción de la barra de navegación superior, la configuración y las direcciones URL.

Este código es probablemente un archivo de configuración que exporta valores y objetos estáticos que se utilizarán en otras partes de la aplicación. Al hacerlo, permite centralizar la configuración y hacerla más fácil de mantener y actualizar.





 */
